var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"nav-item"},[_c('router-link',_vm._g({staticClass:"nav-link position-relative",class:{
                    disabled: _vm.disabled
                 },attrs:{"to":_vm.to,"disabled":_vm.disabled}},_vm.$listeners),[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }